import React from 'react';
import { Row, Column } from 'components/Layout/Grid';

import grupoMafra from 'img/logo-grupo-mafra.svg';
import groupCompanies from 'img/ccare-rodape.png';
import Text from 'components/Text';
import { useLocation } from 'react-router-dom';

export const Footer: React.FC = () => {
  const location = useLocation();

  return (
    <Row
      className={`bg-white w-100 align-center align-md-none mt-6 flex-md-column justify-between ${location.pathname === '/carta-correcao' || location.pathname === '/manutencao' ? 'footer' : ''}`}
      style={{ minHeight: 127, borderTop: ' 1px solid #D3D3D3' }}
    >
      <Row
        className="pl-8 pl-lg-3 py-md-4 border-md-none w-md-100 d-md-none"
      >
        <img src={grupoMafra} alt="grupo mafra" style={{ minHeight: 77 }} />
      </Row>

      <Column className="px-8 px-lg-4 py-md-4">
        <Text className="color-blue-gray font-bold" size={10}>
          EMPRESAS DO GRUPO
        </Text>
        <img src={groupCompanies} alt="empresas do grupo" />
      </Column>
      <Row className="w-md-100 pr-8 pr-lg-3 d-md-none" style={{ width: 293 }} />
    </Row>
  );
};
